import React from "react";
import { cn } from "@/lib/utils";
import { Link } from "react-router-dom";

interface Props {
  href?: string;
  label?: string;
  className?: string;
}

export const LinkCell: React.FC<Props> = ({ href, label, className }) => {
  if (!href || !label) {
    return <div className={cn("text-center", className)}>-</div>;
  }

  return (
    <Link
      to={href}
      onClick={(event) => event.stopPropagation()}
      className={cn("hover:underline text-center", className)}
    >
      {label}
    </Link>
  );
};
